import { TEAPLUS_LOGO } from '@teaplus/shared';
import { cn } from '@/lib/cn';

/** The "Tea+" logo. It takes the accent colour, which is Aqua by default. */
export function TeaPlusLogo({ className, compact }: { className?: string; compact?: boolean }) {
  return (
    <svg
      viewBox={`0 0 ${TEAPLUS_LOGO.width} ${TEAPLUS_LOGO.height}`}
      role="img"
      aria-label="Tea+"
      className={cn('w-auto shrink-0 select-none', compact ? 'h-6' : 'h-7', className)}
    >
      <path fill="var(--color-pink)" fillRule="evenodd" d={TEAPLUS_LOGO.path} />
    </svg>
  );
}
